import { storageKeys } from './keys';
import { removeFromStorage } from './remove';

export const clearStorage = () => storageKeys.map(key => removeFromStorage(key));
